/**
 *  Vuex Rest API
 *
 *  @model Device
 */
import Vapi from 'vuex-rest-api'
import apiConfig from '@/config/api'
import { getPaginated } from '@/helpers/general'
import { axiosInstance } from '../../../plugins/axios'
import { state } from './state'
import { mutations } from './mutations'
import { orderItems } from './parse'

/**
 *  Devices on REST API
 */

const setMessage = (type, message, error) => {
  const errorOrEmpty = error ? `: ${error}` : ''
  return { show: true, type, message: `${message}`, errorOrEmpty }
}

const api = new Vapi({
  axios: axiosInstance,
  baseURL: apiConfig.url,
  state
}).get({
  action: 'getTag',
  property: 'tag',
  path: ({ id }) => `/tags/${id}`
}).post({
  action: 'attachTag',
  property: 'tag',
  path: () => '/tags'
}).post({
  action: 'createTag',
  property: 'tag',
  path: () => '/tags',
  onSuccess (state, { data }) {
    state.tags = [...state.tags, data.data]
    state.error = setMessage('success', 'Successfully created tag.')
  },
  onError: (state, error) => {
    state.error = setMessage('error', 'Something went wrong while creating this tag', error)
  }
}).post({
  action: 'createTagGroup',
  property: 'group',
  path: () => '/tag-groups',
  onSuccess (state, { data }) {
    state.error = setMessage('success', 'Successfully created tag group.')
  },
  onError: (state, error) => {
    state.error = setMessage('error', 'Something went wrong while creating this tag group', error)
  }
  // TODO: AttachTags now adds new tag group to the state. Preferably should be done by createTagGroup and updateTagGroup, which should return group with attached tags.
}).post({
  action: 'attachTags',
  property: 'tags',
  path: () => '/tags/attach',
  onSuccess (state, { data }) {
    const groupsWithoutUpdatedGroup = state.groups.filter(g => g.id !== data.data.id)
    state.groups = orderItems(
      [...groupsWithoutUpdatedGroup, data.data]
    )
  },
  onError: (state, error) => {
    state.error = setMessage('error', 'Something went wrong while attaching tags to this group', error)
  }
}).post({
  action: 'addTagToGroup',
  property: 'tags',
  path: () => '/tags/add-tag-to-group'
}).get({
  action: 'getTags',
  property: 'tags',
  path: (params) => getPaginated(params, 'tags'),
  onSuccess (state, payload) {
    state.tags = payload.data.data
  }
}).get({
  action: 'getTagGroups',
  property: 'groups',
  path: (params) => getPaginated(params, 'tag-groups'),
  onSuccess (state, payload) {
    state.groups = orderItems(
      payload.data.data
    )
  }
}).put({
  action: 'updateTag',
  property: 'tag',
  path: ({ id }) => `/tags/${id}`,
  onSuccess (state, { data }) {
    const { id } = data.data
    const newTags = state.tags.map(t => t.id === id ? data.data : t)
    state.tags = newTags
  },
}).put({
  action: 'updateTagGroup',
  property: 'tag',
  path: ({ id }) => `/tags/${id}`,
  onSuccess (state, payload) {
    // TODO: Refactor!
    const { id } = payload.data.data
    const newGroups = state.groups.map(t => t.id === id ? payload.data.data : t)
    state.groups = newGroups
  }
}).delete({
  action: 'deleteTag',
  property: 'tag',
  path: (params) => `/tags/${params.id}`,
  onSuccess (state, payload) {
    // TODO: Refactor!
    const { id } = payload.data.data
    const newTags = state.tags.filter(t => t.id !== id)
    const newGroups = state.groups.map(t => ({ ...t, tags: t.tags.filter(tt => tt.pivot.tag_id !== id) }))
    state.tags = newTags
    state.groups = newGroups
    state.error = setMessage('success', 'Successfully deleted this tag.')
  }
}).delete({
  action: 'deleteTagGroup',
  property: 'tag',
  path: ({ id }) => `/tags/${id}`,
  onSuccess (state, payload) {
    // TODO: Refactor!
    const { id } = payload.data.data
    const newTags = state.groups.filter(t => t.id !== id)
    state.groups = newTags
    state.error = setMessage('success', 'Successfully deleted this tag group.')
  },
  onError: (state, error, axios, { params, data }) => {
    state.error = setMessage('error', 'Something went wrong while deleting this tag group', error)
  }
})

const Tags = api.getStore({
  namespaced: true,
  createStateFn: true
})

Tags.mutations = {
  ...Tags.mutations,
  ...mutations
}

export default Tags
